import React from "react";
import moment from "moment";

class ReportModalCM extends React.Component {
  render() {
    const {data, user} = this.props;
    let hoy = new Date();
    var Hora = hoy.getHours();
    var Min = hoy.getMinutes();
    var Fecha = hoy.toLocaleDateString();

    let subTotal = 0;
    let total = 0;
    let IGV = 0;
    let tax = 0;
    !!data && data.map(item => {            
        let totalPrice = Number((item.Price * item.quantity) - ((item.Price * item.quantity) * (item.Discount / 100)));
        subTotal += totalPrice;
        tax = item.taxRate;
    });
    IGV = tax * subTotal / 100;
    total = subTotal + IGV;

    if(data.length === 0){
    return (
        <div></div>
    );
    }
    return (
      <div>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width: '50px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{width: '50px',textAlign:'center', paddingTop:'70px'}}>
              <img style={{width: '100%', height:'auto'}} src="https://rintisa.com.pe/images/logo.svg" />
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{textAlign:'center'}}>
              <h2 style={{fontWeight:'bold'}}>ORDEN DE VENTA</h2>
            </th>
            <th style={{visibility:'hidden'}}>a</th>
          </thead>
        </table>
        <br></br>        
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{textAlign:'center'}}>
              <h3 style={{fontWeight:'bold'}}>RUC: {user.CardCode.substring(1)}</h3>    
            </th>
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>{Fecha}-{Hora}:{Min}hs</h3>
            </th>
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>{user.CardName}</h3>
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%', borderCollapse: 'collapse'}}>
          <tr style={{backgroundColor:'#0078C0',paddingTop: '12px', paddingBottom: '12px', textAlign: 'left', color: 'white'}}>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{textAlign:'center'}}>#</th>
            <th style={{textAlign:'center'}}>EAN</th>
            <th style={{textAlign:'left'}}>Producto</th>
            <th style={{textAlign:'center'}}>Cantidad</th>
            <th style={{textAlign:'center'}}>Peso neto</th>
            <th style={{textAlign:'center'}}>Peso Bruto</th>
            <th style={{textAlign:'center'}}>Precio unitario</th>
            <th style={{textAlign:'center'}}>Descuento</th>
            <th style={{textAlign:'center'}}>Precio total</th>            
            <th style={{visibility:'hidden'}}>a</th>
          </tr>
          {!!data && data.map((item, index) => {
            return (
                  <tr>
                    <th style={{visibility:'hidden'}}>a</th>
                    <th style={{textAlign:'center'}}>{index+1}</th>
                    <th style={{textAlign:'center'}}>{item.ItemCode}</th>
                    <th style={{textAlign:'left', fontSize:12}}>{item.ItemName}</th>                       
                    <th style={{textAlign:'center'}}>{parseInt(item.quantity)}</th>
                    <th style={{textAlign:'right'}}>{parseFloat(item.quantity * item.weight).toFixed(2)+' KG'}</th>
                    <th style={{textAlign:'right'}}>{parseFloat(item.quantity * item.weight1).toFixed(2)+' KG'}</th>
                    <th style={{textAlign:'right'}}>S/{parseFloat(item.priceTax).toFixed(2)}</th>
                    <th style={{textAlign:'right'}}>{item.Discount === null ? '0.00 %' : parseFloat(item.Discount).toFixed(2) + ' %'}</th>
                    <th style={{textAlign:'right'}}>S/{parseFloat(item.priceTax * item.quantity).toFixed(2)}</th>
                    <th style={{visibility:'hidden'}}>a</th>
                  </tr> 
                );
            })
          }    
          <tr>
              <th style={{visibility:'hidden'}}>a</th>
              <th colspan="9" style={{textAlign:'right'}}></th>
              <th style={{visibility:'hidden'}}>a</th>
          </tr>
          <tr>
              <th style={{visibility:'hidden'}}>a</th>
              <th colspan="8" style={{textAlign:'right'}}>Subtotal:</th>  
                          
              <th style={{textAlign:'right'}}>S/{parseFloat(subTotal).toFixed(2)}</th>
              <th style={{visibility:'hidden'}}>a</th>
          </tr>
          <tr>
              <th style={{visibility:'hidden'}}>a</th>
              <th colspan="8" style={{textAlign:'right'}}>I.G.V.:</th>
              <th style={{textAlign:'right'}}>S/{parseFloat(IGV).toFixed(2)}</th>
              <th style={{visibility:'hidden'}}>a</th>
          </tr>
          <tr>
              <th style={{visibility:'hidden'}}>a</th>
              <th colspan="8" style={{textAlign:'right'}}>Total:</th>
              <th style={{textAlign:'right'}}>S/{parseFloat(total).toFixed(2)}</th>
              <th style={{visibility:'hidden'}}>a</th>
          </tr>
        </table>    
        <br></br>        
      </div>
    );
  }
}

export default ReportModalCM;